import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserTypesService } from 'src/app/core/api-services/user-profile/user-types.service';
import {
  User,
  UserTypesModel,
} from 'src/app/core/models/user-profile/user-types.model';
import { UtilService } from 'src/app/core/utilities/util.service';
import { AuthService } from 'src/app/shared/authentication/auth.service';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';

@Component({
  selector: 'app-user-types',
  templateUrl: './user-types.component.html',
  styleUrls: ['./user-types.component.scss'],
})
export class UserTypesComponent extends BaseComponent implements OnInit {
  retUrl: string = null;
  UserTypesModel: UserTypesModel;
  sessionKey: string = '';
  code: string = '';
  state: string = '';
  error: string = '';
  errorMessage: string = '';
  constructor(
    translateService: TranslateService,
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    public utilService: UtilService,
    private _service: UserTypesService,
  ) {
    super(translateService);

    this.translateService.onLangChange.subscribe((langChangeEvent) => {});
  }

  ngOnInit(): void {
    if (this.auth.isAuthenticated()) {
      this.router.navigate(['/home']);
    }
    this.route.queryParams.subscribe((params) => {
      this.code = params['code'];
      this.sessionKey = params['SessionKey'];
      this.state = params['state'];
      this.error = params['error'];
      if (params['retUrl']) {
        this.retUrl = params['retUrl'];
      } else {
        this.retUrl = sessionStorage.getItem('retUrl');
      }
    });

    if (!this.error) {
      this.getUsers();
    }
  }

  getUsers() {
    if (this.sessionKey) {
      this._service.GetUsersBySessionKey(this.sessionKey).subscribe(
        (response) => {
          if (response) {
            this.UserTypesModel = response;
          }
        },
        (error) => {
          this.error = error;
        },
      );
    } else {
      this._service.GetUsers(this.code).subscribe(
        (response) => {
          if (response) {
            this.UserTypesModel = response;
          }
        },
        (error) => {
          this.error = error;
        },
      );
    }
  }

  login(user: User) {
    let token = { UserId: user.UserToken };
    this._service.Login(token).subscribe(
      (response) => {
        this.utilService.setLoginCoockies(
          response.Token,
          response.ParticipantId,
          this.lang,
        );
        if (this.retUrl) {
          sessionStorage.removeItem('retUrl');
          window.location.href = this.retUrl;
        } else {
          window.location.href = 'home?dashboard=true';
        }
      },
      (error) => {
        this.error = error;
      },
    );
  }

  navigateToRegistration(userType: number) {
    if (userType != 0) {
      this.router.navigate(['registration'], {
        queryParams: { type: userType, token: this.UserTypesModel.Token },
      });
    }
  }
}
